import { render } from "./TipsLogin.vue?vue&type=template&id=4b29fa81"
import script from "./TipsLogin.vue?vue&type=script&lang=js"
export * from "./TipsLogin.vue?vue&type=script&lang=js"

import "./TipsLogin.vue?vue&type=style&index=0&id=4b29fa81&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__